import React, { useState } from 'react'
import {
  Box,
  Card,
  Chip,
  Grid2,
  IconButton,
  Input,
  InputAdornment,
  Toolbar,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { FilterList, Search, ViewList, ViewModule } from '@mui/icons-material'
import CloseIcon from '@mui/icons-material/Close'
import useSideScreen from '../Layout/Hooks/useSideScreen'
import FilterSideScreen from './filters/FilterSideScreen'
import Text from '../genericComponents/Text'

const ActionBar = ({
  filters,
  setFilters,
  toolbarOptions,
  columns,
  selectedItems,
  setSelectedItems,
  getSelectedItemOptions,
  multiSelectedItemOptions,
  searchValue,
  isCards,
  setSearchValue,
  toggleGridView,
  gridView,
  typeName,
}) => {
  const [searchActive, setSearchActive] = useState(false)
  const { openSideScreen } = useSideScreen()
  const theme = useTheme()
  const isXs = useMediaQuery(theme.breakpoints.down('sm'))

  const handleNewFilters = (index) => {
    const newFilters = [...filters]
    newFilters.splice(index, 1)
    setFilters(newFilters)
  }
  const isMultiselected=selectedItems.length>1;
  
  if (selectedItems[0]) {
    const selectOptions=!isMultiselected?getSelectedItemOptions (selectedItems[0]):multiSelectedItemOptions;
    return (
      <Card style={{ backgroundColor: theme.palette.secondary.main }}>
        <Box sx={{ flexGrow: 1 }} />
        <Toolbar variant='dense'>
          <Box sx={{ flexGrow: 1 }} />
          <Grid2
            container
            justify='space-between'
            alignItems='center'
            style={{
              // marginBottom: theme.spacing(),
              height: theme.spacing(3),
            }}
          >
            <Grid2 style={{ color: 'white',display:"flex", marginLeft: theme.spacing(1) }}>
              <Box sx={{mr:1}}>{selectedItems.length}</Box> <Text text='i18n_selected' />
            </Grid2>
            <div style={{ flex: 1 }} />            
            <Grid2 sx={{display:{xs:"none",md:"block"}}}>
              { selectOptions.map((item, i) =>{ 
                const Icon=item.icon;
                return (
                <IconButton
                  style={{
                    color: 'white',
                    marginLeft: theme.spacing(1)
                  }}
                  onClick={() => {
                    item.onClick(isMultiselected?selectedItems:selectedItems[0])
                    setSelectedItems([])
                  }}
                  key={i}
                >
                 <Icon/>
                </IconButton>
              )})}
              {toolbarOptions && (theme.isXs === true || (isXs && theme.isXs === undefined)) && toolbarOptions.map((option, i) => {
                const Icon=option.icon;
                
                return (
                <IconButton
                  onClick={option.onClick}
                  style={{
                    color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
                    marginLeft: theme.spacing(1)
                  }}
                  id={option.id}
                  key={i}
                >
                  <Icon/>
                </IconButton>
              )})}
              <IconButton
                style={{
                  color: 'white',
                  marginLeft: theme.spacing(1)
                }}
                onClick={() => setSelectedItems([])}
              >
                <CloseIcon />
              </IconButton>
            </Grid2>
          </Grid2>
        </Toolbar>
      </Card>
    )
  }
  const isMobile = (theme.isXs !== undefined) || (isXs && theme.isXs === undefined);
  const handleSetSearchActive = () => {
    setSearchActive(true)
    setTimeout(() => {
      document.getElementById('search').focus()
    }, 0)
  }

  return (
    <Grid2 component={isCards ? Card : null}>
      <Box sx={{ flexGrow: 1 }}>
        <Toolbar variant='dense'>
          {filters.map((x, i) => (
            <Chip
              label={x.comparator.pillText(x.column.propertyName, x.filterValues)}
              style={{ marginRight: theme.spacing(0.5) }}
              color='secondary'
              onDelete={() => handleNewFilters(i)}
              variant='outlined'
              key={i}
            />
          ))}
          <Box sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }} />
          {!isMobile ? <Input
            type='search'
            id='search'
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder='Search...'
            disableUnderline
            onClick={handleSetSearchActive}
            autoFocus
            disabled={!searchActive}
            onBlur={() => !searchValue && setSearchActive(false)}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  disableRipple
                  style={{
                  }}>
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            style={{
              padding: theme.spacing(0.5),
              paddingLeft: theme.spacing(1),
              borderRadius: 9001,
              flexBasis: 0,
              maxWidth: 250,
              flexGrow: searchActive ? 1 : 0,
              transitionDuration: '.5s',
              cursor: !searchActive && 'pointer'
            }}
          />
            : (<Input
              type='search'
              id='search'
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder='Search...'
              disableUnderline
              onClick={handleSetSearchActive}
              autoFocus
              onBlur={() => !searchValue && setSearchActive(false)}
              startAdornment={
                <InputAdornment position='start'>
                  <IconButton disableRipple>
                    <Search />
                  </IconButton>
                </InputAdornment>
              }
              style={{
                padding: theme.spacing(0.25),
                borderRadius: 9001,
                flexBasis: 0,
                flexGrow: 1,
              }}
            />)
          }

          <IconButton
            style={{
              color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
              marginLeft: theme.spacing(1)
            }}
            onClick={() =>
              openSideScreen(FilterSideScreen, {
                data: { columns, filters, setFilters, typeName }
              })
            }>
            <FilterList />
          </IconButton>
          {!isMobile ? <IconButton
            style={{
              color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
              marginLeft: theme.spacing(1)
            }}
            onClick={toggleGridView}
          >
            {gridView ? <ViewList /> : <ViewModule />}
          </IconButton>
            : null}

          {!isMobile && toolbarOptions && toolbarOptions.map((option, i) => {
            const Icon=option.icon;
            return(
            <IconButton
              onClick={option.onClick}
              style={{
                color: theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
                marginLeft: theme.spacing(1)
              }}
              id={option.id}
              key={i}
            >
              <Icon/>
            </IconButton>
          )})}
        </Toolbar>
      </Box>
    </Grid2>
  )
}

export default ActionBar
